import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useContext } from "react";
import { useLoaderData, useNavigation } from "react-router-dom";
import Lottie from "lottie-react";
import payment from "../../payment.json";
import CheckoutForm from "./CheckoutForm";
import Loader from "../Shared/Loader/Loader";
import { AuthContext } from "../../contexts/AuthProvider/AuthProvider";
import { TypeAnimation } from "react-type-animation";
import "./Payment.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
console.log("stripePromise:", stripePromise);

const Payment = () => {
  const order = useLoaderData();
  const navigation = useNavigation();

  const { user } = useContext(AuthContext);

  const { title, price } = order;

  // console.log("order:", order);

  if (navigation.state === "loading") {
    return <Loader />;
  }

  return (
    <div className="d-flex flex-column flex-md-row justify-content-around align-items-center payment-container">
      <div
        className="lottie-payment p-md-5"
        data-aos="fade-down-right"
        data-aos-duration="2500"
      >
        <Lottie animationData={payment} loop={true} />
      </div>

      <div
        className="mt-5 mt-md-0"
        data-aos="fade-down-left"
        data-aos-duration="2500"
      >
        <h3 className="fs-2 fw-semibold mb-3 text-center">
          Online Payment Process
        </h3>

        <p className="fs-5 text-center ms-1 me-1">
          Please pay
          <span className="fw-bold text-bdt  ms-1 me-2">${price}</span>
          for
          <span className="fw-bold mx-1 text-info">
            <TypeAnimation
              sequence={[`${title}`, 3000]}
              speed={10}
              cursor={true}
              repeat={Infinity}
            />
          </span>
        </p>
        <div
          className="mt-4 mt-md-5 mx-auto rounded-4 shadow  payment-card card-log border-top"
          title="Example Visa Card: (4242 4242 4242 4242) + (02/27) + (123) + (12345)"
        >
          <Elements stripe={stripePromise}>
            <CheckoutForm order={order} user={user} />
          </Elements>
        </div>
      </div>
    </div>
  );
};

export default Payment;
